var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"wizard"},[_c('div',{staticClass:"form-container form-container--notfirst"},[_vm._t("default",null,{"currentStep":_vm.currentStep})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }